import { MutationTree } from 'vuex';
import { ORG } from '../mutation_types';
import { IORGSTATE } from '../state.d';

const state: IORGSTATE = {
  cunsumeShow: false,
  moduleUpdate: {
    info: false,
    cost: false,
    recharge: false,
    consume: false,
  },
  curComp: 'Account',
  curCompRefresh: false,
};

/* eslint-disable no-param-reassign */
const mutations: MutationTree<IORGSTATE> = {
  [ORG.SET_ORG_CONSUME_SHOW]: (s, status: boolean) => {
    s.cunsumeShow = status;
  },
  [ORG.SET_ORG_INFO_STATUS]: (s, status: boolean) => {
    s.moduleUpdate.info = status;
  },
  [ORG.SET_ORG_COST_STATUS]: (s, status: boolean) => {
    s.moduleUpdate.cost = status;
  },
  [ORG.SET_ORG_CONSUME_STATUS]: (s, status: boolean) => {
    s.moduleUpdate.consume = status;
  },
  [ORG.SET_ORG_RECHARGE_STATUS]: (s, status: boolean) => {
    s.moduleUpdate.recharge = status;
  },
  [ORG.SET_ORG_BTN_COMPENT]: (s, v: string) => {
    s.curComp = v;
  },
  [ORG.SET_ORG_COMPENT_REFRESH]: (s, v: boolean) => {
    s.curCompRefresh = v;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
